import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { ImpersonationBanner } from './ImpersonationBanner'

export function AppShell() {
  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <ImpersonationBanner />
        <Topbar />
        {/* Conteúdo principal: full width até o cap de 7xl (1280px), centralizado.
            A topbar permanece full-width acima — não entra nesse wrapper. */}
        <main className="flex-1 overflow-y-auto">
          <div className="w-full max-w-7xl mx-auto px-3 sm:px-6 py-6 sm:py-8">
            <Outlet />
          </div>
        </main>
        <footer className="border-t border-gray-100">
          <div className="w-full max-w-7xl mx-auto px-3 sm:px-6 py-3 text-[11px] text-gray-400">
            © {new Date().getFullYear()} Ampla Mais Benefícios — Painel administrativo
          </div>
        </footer>
      </div>
    </div>
  )
}
